import { Header, Link, Table, TableColumn } from '@backstage/core-components';
import React, { useEffect, useMemo, useState } from 'react'
import axios from 'axios';
import { Button, makeStyles, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { discoveryApiRef, useApi, identityApiRef,fetchApiRef } from '@backstage/core-plugin-api';
import Loader from '../loader/Loader';
import { useNavigate } from 'react-router-dom';

const useStyles=makeStyles({
  container:{
    padding:'40px'
  },
  emptyRows:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh', // or '100vh' if you want to center in the whole viewport
    fontSize: '1.3rem', // Increase as needed, e.g., '1.5rem'
    fontWeight: 'bold',
    color: '#555',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',   // button on left, dropdown on right
    alignItems: 'center',
    marginTop: '30px',
    marginRight: '38px',
    marginLeft: '38px',
  },
});

export function RegisterComponentButton() {
  const navigate = useNavigate();
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/catalog-import')}
        style={{ marginBottom: 16 }}
      >
        Register Existing Component
      </Button>
    </div>
   
  );
}

export default function GithubPage() {
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh" }), []);
  const [repos, setRepos] = useState<any[]>([]);
  const styles = useStyles();
  const discoveryApi = useApi(discoveryApiRef);
  const [org, setOrg] = useState('');
  const identityApi = useApi(identityApiRef);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState('');
  const [tenants, setTenants] = useState<{ id: number; name: string }[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<string>('all');

  const formatData = (response: any) => {
    let listOfRepos = response.filter((item: any) => {
      return !item.metadata.annotations['terraform.io/organization'];
    });
    return listOfRepos.map((item: any) => ({
      name: item.metadata.name,
      description: item.metadata.description,
      owner: item.spec.owner,
      service: item.spec.type,
      lifecycle: item.spec.lifecycle,
      entity: item
    }));
  };

  const fetchTenantsFromDb = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      const response = await axios.get(`${baseUrl}/tenants`);
      setTenants(response.data);
      return response.data;
    } catch (e) {
      console.error('Error fetching tenants:', e);
      return [];
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const details = await identityApi.getBackstageIdentity();
      const tenantId = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('tenantId:')
      )?.split(':')[1];

      const userRole = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('role:')
      )?.split(':')[1];
      setRole(userRole);

      const tenantsFromDb = await fetchTenantsFromDb();
      const tenant = tenantsFromDb.find(t => t.id.toString() === tenantId);
      setOrg(tenant.name);
      
      const baseUrl = await discoveryApi.getBaseUrl('catalog');
      let response;
      if (userRole === 'SuperAdmin') {
        response = await axios.get(`${baseUrl}/entities?filter=kind=component`);
      } else {
        response = await axios.get(
          `${baseUrl}/entities?filter=kind=component,metadata.annotations.tenant.com/tenant-id=${tenantId}`
        );
      }

      const filteredRepos = response.data.filter((entity: any) => {
        const annotations = entity?.metadata?.annotations || {};
        return annotations['tenant.com/tenant-id'];
      });
 
      // enrich with tenant names
      const enrichedRepos = filteredRepos.map((entity: any) => {
        const annotations = entity?.metadata?.annotations || {};
        const entityTenantId = parseInt(annotations['tenant.com/tenant-id'], 10);
        const matchedTenant = tenantsFromDb.find((t: any) => t.id === entityTenantId);
        return {
          ...entity,
          tenantName: matchedTenant ? matchedTenant.name : 'Unknown',
        };
      });
 
      // unique tenants for dropdown
      const uniqueTenants = Array.from(
        new Map(
          enrichedRepos.map((entity: any) => {
            const id = parseInt(entity.metadata.annotations['tenant.com/tenant-id'], 10);
            return [id, { id, name: entity.tenantName }];
          })
        ).values()
      );
      
      // setTenants(uniqueTenants);

      const listOfRepos = formatData(enrichedRepos);
      setRepos(listOfRepos);
      setLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleTenantChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const tenantId = event.target.value as string;
    setSelectedTenant(tenantId);

    // if (tenantId === 'all') {
    //   setOrg('All Tenants');
    // } else {
    //   const tenant = tenants.find(t => t.id.toString() === tenantId);
    //   if (tenant) {
    //     setOrg(tenant.name);
    //   }
    // }
  };

  const columns: TableColumn[] = [
    {
      title: 'Name',
      field: 'name',
      highlight: true,
      render: ({ entity }) => (
        <Link to={`/catalog/default/component/${entity?.metadata?.name}`}>
          {entity?.metadata?.name}
        </Link>
      ),
    },
    { title: 'Description', field: 'description' },
    { title: 'Owner', field: 'owner' },
    { title: 'Service', field: 'service' },
    { title: 'Lifecycle', field: 'lifecycle' },
  ];

  // filter repos by selectedTenant
  const filteredRepos =
    selectedTenant === 'all'
      ? repos
      : repos.filter(
        repo =>
          repo.entity.metadata.annotations['tenant.com/tenant-id'] === selectedTenant
      );

  useEffect(() => {
    fetchData();
  },[])
  return (
    <div style={containerStyle}>
      <Header title={'CloudOPS Github Repos'} subtitle={org} />

      <div className={styles.buttonContainer}>
        <RegisterComponentButton />
        {role === 'SuperAdmin' && (
          <FormControl variant="outlined" size="small" style={{ minWidth: 220 }}>
            <InputLabel id="tenant-select-label"></InputLabel>
            <Select
              labelId="tenant-select-label"
              value={selectedTenant}
              onChange={handleTenantChange}
              displayEmpty
            >
              <MenuItem value="all">All Tenants</MenuItem>
              {tenants.map(tenant => (
                <MenuItem key={tenant.id} value={tenant.id.toString()}>
                  {tenant.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </div>

      <div className={styles.container}>
        {loading ? (
          <Loader />
        ) : filteredRepos.length > 0 ? (
          <Table
            options={{ paging: false }}
            data={filteredRepos}
            columns={columns}
            title="Repositories"
          />
        ) : (
          <div className={styles.emptyRows}>
            No repositories found. Please Register
          </div>
        )}
      </div>
    </div>
  );
}
